export default {
  nodes: [
    {
      match: [
        {
          object: 'block',
          type: 'paragraph',
        },
        {
          object: 'block',
          type: 'unordered_list',
        },
        {
          object: 'block',
          type: 'list_item',
        },
      ],
    },
  ],
};
